import { render, staticRenderFns } from "./WorkplaceDueDateRulesModal.vue?vue&type=template&id=49ac063a&"
import script from "./WorkplaceDueDateRulesModal.vue?vue&type=script&lang=js&"
export * from "./WorkplaceDueDateRulesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports